// src/composables/useIdleCounter.js
import { computed, watch } from 'vue'
import { useCounter, useIdle, useTimestamp } from '@vueuse/core'
import { useAuthStore } from '@/stores/auth'

export const useIdleCounter = () => {
  const timeout = 15 * 60 * 1000 // 1 minuto por defecto
  const { inc } = useCounter()
  const { idle, lastActive } = useIdle(timeout)
  const now = useTimestamp({ interval: 1000 }) // Actualiza cada segundo

  // Calcula el tiempo que ha pasado desde la última actividad
  const idledFor = computed(() => Math.floor((now.value - lastActive.value) / 1000))

  // Observa los cambios en el estado de inactividad
  watch(idle, (idleValue) => {
    if (idleValue) {
      inc() // Incrementa el contador si el usuario está inactivo
      const authStore = useAuthStore()
      authStore.logout()
    }
  })

  // Corrigiendo el watch de idledFor
  // watch(idledFor, (newValue) => {
  //   console.log(newValue)
  //   if (newValue === 0) {
  //     console.log(`El usuario está activo de nuevo. Contador reseteado.`)
  //   }
  // })

  return { idledFor }
}
